var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 49,
  height: 49,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  d: "M48.25 24.629c0 12.979-10.521 23.5-23.5 23.5s-23.5-10.521-23.5-23.5 10.521-23.5 23.5-23.5 23.5 10.521 23.5 23.5Z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#x_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m26.274 23.252 5.957-7.623H30.82l-5.175 6.617-4.13-6.617H16.75l6.247 10.007-6.247 7.993h1.411l5.461-6.99 4.363 6.99h4.765M18.67 16.8h2.168l9.98 15.715H28.65"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "x_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.75 15.629h16v18h-16z"
})))));
export default SvgX;